export let mappingTask = {
    timeframe: [
        "Zeitraum",
        {
            start: ["Start"],
            end: ["Ende"],
        },
    ],
    taskType: [
        "Einsatzart",
        {
            oilSpillRemoval: ["Ölspur beseitigung"],
            towing: ["Abschleppung"],
        },
    ],
    editedBy: ["Abgeschlossen von"],
    status: [
        "Status",
        {
            inProgress: ["In Bearbeitung"],
            completed: ["Abgeschlossen"],
            deleted: ["gelöscht"],
        },
    ],
    completedSteps: [
        "Abgeschlossene Schritte",
        {
            stepNr: ["Schritt Nr."],
            completedAt: ["Abgeschlossen am"],
            completedBy: ["Abgeschlossen von"],
        },
    ],
    generalDetails: [
        "Allgemeine Angaben",
        {
            location: [
                "Standort",
                {
                    langitude: ["Längengrad"],
                    latitude: ["Breitengrad"],
                    name: ["Name"],
                },
            ],
            description: ["Beschreibung"],
            shortDescription: ["Kurzbeschreibung"],
        },
    ],
    meta: [
        "Metadaten",
        {
            createdBy: [
                "Erstellt von",
                {
                    userId: ["Benutzer-ID"],
                    name: ["Name"],
                },
            ],
            editedBy: [
                "Bearbeitet von",
                [
                    {
                        userId: ["Benutzer-ID"],
                        name: ["Name"],
                    },
                ],
            ],
            executingCompany: ["Ausführende Firma"],
            contactPerson: ["Ansprechpartner"],
        },
    ],
    details: [
        "Details",
        {
            actions: [
                "Aktionen",
                {
                    accidentSceneCleanup: ["Unfallstelle reinigen"],
                    soilAndWaterRemediation: ["Boden- und Wassersanierung"],
                    measurement: ["Messung"],
                    trafficAreaCertificateOrOilRemoval: ["Verkehrsflächenzertifikat oder Ölspurbeseitigung"],
                },
            ],
            diaryNumber: ["Tagebuchnummer"],
            conditions: [
                "Bedingungen",
                {
                    dry: ["Trocken"],
                    wet: ["Nass"],
                    snow: ["Schnee"],
                    rain: ["Regen"],
                    moist: ["Feucht"],
                    sun: ["Sonne"],
                },
            ],
            temperature: ["Temperatur in Grad"],
            alarmingInstitutions: ["Alarmierende Institution"],
            alarmingPoliceStation: ["Alarmierende Polizeistation"],
            orderId: ["Auftragsnummer"],
        },
    ],
    vehicles: [
        "Fahrzeuge",
        {
            vehicleObjects: [
                "Fahrzeugdaten",
                {
                    driver: [
                        "Fahrer",
                        {
                            userId: ["Benutzer-ID"],
                        },
                    ],
                    coDriver: [
                        "Beifahrer",
                        {
                            userId: ["Benutzer-ID"],
                        },
                    ],
                    vehicle: [
                        "Fahrzeug",
                        {
                            id: ["Fahrzeug-ID"],
                            categoryId: ["Kategorie-ID"],
                        },
                    ],
                    equipment: [
                        "Ausrüstung",
                        {
                            id: ["Ausrüstungs-ID"],
                        },
                    ],
                },
            ],
            additionalEquipment: [
                "Zusätzliche Ausrüstung",
                {
                    ids: ["Ausrüstungs-IDs"],
                },
            ],
        },
    ],
    responsiblePerson: [
        "Verantwortliche Person",
        {
            address: [
                "Adresse",
                {
                    fullName: ["Name"],
                    street: ["Straße"],
                    zipCode: ["PLZ"],
                    city: ["Stadt"],
                },
            ],
            vehicleName: ["Fahrzeugname"],
            licensePlate: ["Kennzeichen"],
            country: ["Land"],
            insurance: ["Versicherung"],
            insuranceNumber: ["Versicherungsnummer"],
            images: ["Bilder"],
        },
    ],
    images: [
        "Bilder",
        {
            id: ["Datei"],
            comment: ["Kommentar"],
            inMissionProtocol: ["Im Einsatzprotokoll"],
        },
    ],
    files: [
        "Dateien",
        {
            id: ["Datei"],
        },
    ],
    damageDetails: [
        "Schadensdetails",
        {
            underground: [
                "Untergrund",
                {
                    imageIds: ["Untergrundbilder"],
                    types: ["Untergrund"],
                },
            ],
            leakedSubstances: [
                "Ausgelaufene Substanzen",
                {
                    imageIds: ["Ausgelaufene Substanzenbilder"],
                    types: ["Ausgelaufene Substanzen"],
                },
            ],
            causes: [
                "Ursache",
                {
                    imageIds: ["Ursachenbilder"],
                    types: ["Ursache"],
                },
            ],
        },
    ],
    usages: [
        "Verwendungen",
        {
            name: ["Material"],
            amount: ["Menge"],
            unit: ["Einheit"],
            materialImageIds: ["Materialbilder"],
        },
    ],
    cleaedAreas: [
        "Gereinigte Flächen",
        {
            length: ["Länge"],
            width: ["Breite"],
            height: ["Höhe"],
            underground: ["Untergrund"],
            street: ["Straße"],
            cleaningImageIds: ["Reinigungsbilder"],
        },
    ],
    pollutionDetails: [
        "Verschmutzungsdetails",
        {
            notes: ["Notizen"],
            disposals: [
                "Entsorgungen",
                {
                    materialId: ["Material"],
                    materialImageIds: ["Materialbilder"],
                    amount: ["Menge"],
                    width: ["Breite"],
                    length: ["Länge"],
                },
            ],
        },
    ],
    manualProtocol: [
        "Manuelle Protokolle",
        {
            entries: [
                "Einträge",
                {
                    datetime: ["Datum"],
                    eventId: ["Event ID"],
                },
            ],
        },
    ],
}
export function translatePath(path) {
    // Split the path into components
    let components = path.split(".")
    /**
     * @type {any}
     */
    let currentMap = mappingTask
    let translatedPath = []

    for (let i = 0; i < components.length; i++) {
        let component = components[i]
        let indexMatch = component.match(/(\w+)\[(\d+)\]/)

        if (indexMatch) {
            let key = indexMatch[1]
            let index = parseInt(indexMatch[2])

            translatedPath.push(`${currentMap?.[key]?.[0] || "?"} &rarr; ${index + 1}. Eintrag`)
            if (!currentMap?.[key]?.[0]) {
                console.log("Key not found", key, component, currentMap, currentMap[key])
            }
            // If there are subfields, update the current map
            if (currentMap[key] && currentMap[key].length > 1) {
                currentMap = currentMap[key][1]
            }
        } else if (currentMap[component]) {
            translatedPath.push(currentMap[component][0])

            // If there are subfields, update the current map
            if (currentMap[component].length > 1) {
                currentMap = currentMap[component][1]
            }
        } else {
            // Iterating over the subarray structure if the direct key isn't found.
            let found = false
            for (let key in currentMap) {
                if (currentMap[key][1] && currentMap[key][1][component]) {
                    translatedPath.push(currentMap[key][1][component][0])
                    if (currentMap[key][1][component].length > 1) {
                        currentMap = currentMap[key][1][component][1]
                    }
                    found = true
                    break
                }
            }
            if (!found) {
                console.error(`Key ${component} not found in currentMap path: ${path}`)
                continue
            }
        }
    }

    // Join the translated path components into a sentence
    return translatedPath.join(" &rarr; ")
}
//
